<template>
  <div class="index">
    <div class="nav-box">
      <p class="title">{{ changBg ==1 ? '个人资料' : changBg ==2 ? '购买记录' : changBg ==3 ? '留言反馈' :'资源征集'}}</p>
      <p class="caption">{{ changBg ==1 ? 'PERSONAL DATA' : changBg ==2 ? 'PURCHASE RECORD' : changBg ==3 ? 'MSEEAGE FEEDBACK' :'READER CENTER' }}</p>
    </div>
    <div class="nav-list">
      <ul class="ul-box">
        <li :class="{'default':(changBg===1)}" @click="changBgs(1)">个人资料</li>
        <li :class="{'default':(changBg===2)}" @click="changBgs(2)">购买记录</li>
        <li :class="{'default':(changBg===3)}" @click="changBgs(3)">留言反馈</li>
        <li :class="{'default':(changBg===4)}" @click="changBgs(4)">资源征集</li>
      </ul>
    </div>
    <div class="page-list">
      <MyInfo v-if="(changBg===1)"/>
      <Purchase v-if="changBg===2 "/>
      <LeaveWord v-if="changBg===3 "/>
      <Resource v-if="changBg===4 "/>
    </div>
    <Login ref="Login"/>
  </div>
</template>

<script>
  import Login from "@/components/common/login/Login.vue";
  import MyInfo from "./page/MyInfo.vue";
  import Purchase from "./page/Purchase.vue";
  import LeaveWord from "./page/LeaveWord.vue";
  import Resource from "./page/Resource.vue";

  export default {
    components: {MyInfo, Purchase, Resource, LeaveWord, Login},
    data() {
      return {
        changBg: 4,
      };
    },
    created() {
      if (!this.$store.state.userInfo.userId) {
        this.$confirm("请登录")
          .then(() => {
            this.$refs.Login.openDialog(false);
          })
          .catch(() => {
            this.$router.push("/");
          });
      }
    },
    methods: {
      changBgs(i) {
        this.changBg = i
      }
    }
  };
</script>

<style lang="less" scoped>
  .index {
    .nav-box {
      height: 6.792rem;
      background: url("../../assets//image/news/nav.png");
      color: #582800;
      text-align: center;
      padding-top: 2.719rem;

      .title {
        font-weight: bold;
        font-size: 1.458rem;
        padding-bottom: 0.245rem;
        letter-spacing: 2px;
      }

      .caption {
        font-size: 0.938rem;
      }
    }

    .nav-list {
      .ul-box {
        width: 62.5rem;
        color: #333;
        display: flex;
        padding-left: 8.646rem;
        padding-top: 2.064rem;
        padding-bottom: 2.064rem;
        margin: auto;
        text-align: center;
      }

      li {
        width: 10.521rem;
        height: 2.5rem;
        background: url("../../assets//image/reader/nav_bg.png") no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
        line-height: 2.5rem;
        font-size: 1.042rem;
        margin-right: 1.042rem;
      }
    }

    .page-list {
      width: 62.5rem;
      margin: auto;
      margin-bottom: 2.083rem;
    }

    .default {
      background: url("../../assets//image/reader/nav_bgs.png") no-repeat !important;
      background-size: 100% !important;
      color: #582800;
    }
  }
</style>
